import axios from 'axios';
import * as keys from '../../config/apiKeys';

// Returns a promise that will ether resolve or reject.
export default function apiGet(apiUrl, options, q, user, appName, restrictForPublishers, restrictForContributors, skipKey) {
  options = options || {};
  options.headers = options.headers || {};
  if (!skipKey) {
    options.headers['api_key'] = keys.MYAPI_KEY;
  }

  let role = user &&
             user.permissions &&
             user.permissions[appName] &&
             user.permissions[appName].role ?
             user.permissions[appName].role :
             "public";

  let userId = user && user.Id;

  options.params = options.params || {};
  if (restrictForContributors && role === "contributor") {
    options.params["currentAssignee"] = userId;
  }

  if (restrictForPublishers && role === "publisher") {
    options.params["publisher"] = userId;
  }

  if (q) {
    options.params["q"] = q;
  }

  return new Promise((resolve, reject) => {
    var url = window.location.protocol + "//" + window.location.host + apiUrl;
    axios.get(url, options)
      .then((response) => {
        let theData = response.data;
        resolve(theData);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
